import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Workshop } from '@chancenwerk/workshops/entities/Workshop.js';

/**
 * @entity WorkshopAttendanceCount
 */
@Entity()
export class WorkshopAttendanceCount extends AdornisEntity {
  public static override _class = 'WorkshopAttendanceCount';

  public static override resolveID(entity: any): string {
    return entity.workshopID;
  }

  @DataLoadedField(type => Workshop, ({ workshopID }) => workshopID)
  public workshop: Maybe<Workshop>;

  @Field(type => String)
  public workshopID: Maybe<string>;

  @Field(type => Int)
  public eventCount: Maybe<number>;

  @Field(type => Int)
  public attendanceCount: Maybe<number>;

  @Field(type => Int)
  public attendanceCountMin: Maybe<number>;

  @Field(type => Int)
  public attendanceCountMax: Maybe<number>;
}
